import {useFileEdit} from './useFileEdit';

export const useFileEditPermissions = () => {
  const {fileDetails} = useFileEdit();
  return {hasFileEditPermissions: fileDetails?.canEdit ?? false};
};
